import React, { useState, useEffect, useRef, useCallback } from 'react';
import './TestimonialsSection.css';
import { testimonials } from '../../../../data/testimonials';

function TestimonialsCarousel(){
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const intervalRef = useRef(null);
  const focusWithinRef = useRef(false);
  const advance = useCallback((dir = 1) => {
    setIndex(i => (i + dir + testimonials.length) % testimonials.length);
  }, []);
  useEffect(() => {
    if (paused) { if (intervalRef.current) { clearInterval(intervalRef.current); intervalRef.current = null; } return; }
    intervalRef.current = setInterval(() => advance(1), 6000);
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, [paused, advance]);
  const onUserInteract = () => setPaused(true);
  const onResume = () => { if (!focusWithinRef.current) setPaused(false); };
  return (
  <section id="testimonials" className="snap-section m-testimonial m-wrapper" data-section="testimonials" aria-labelledby="m-testimonial-h" aria-roledescription="carousel" aria-label="Student testimonials">
      <div className="m-testimonial-wrap">
        <h2 id="m-testimonial-h" className="m-testimonial-h">Trusted by Students Nationwide</h2>
        <p className="m-testimonial-sub">See why thousands of students rely on DocuHounds to stay organized.</p>
        <div className="m-testimonial-accent" aria-hidden></div>
        <div className="m-tcarousel" role="group" aria-live="polite"
        onMouseEnter={onUserInteract} onMouseLeave={onResume}
        onTouchStart={onUserInteract} onTouchEnd={onResume}
        onFocusCapture={() => { focusWithinRef.current = true; onUserInteract(); }}
        onBlurCapture={() => { focusWithinRef.current = false; onResume(); }}>
        {testimonials.map((t, i) => (
          <figure key={t.name} className={`m-testimonial-card m-tcard ${i === index ? 'active' : 'inactive'}`} aria-hidden={i !== index} tabIndex={i === index ? 0 : -1}>
            <div className="m-testimonial-inner simple refined">
              <div className="m-testimonial-logo-glow">
                {t.logo ? (
                  <img src={t.logo} alt={t.school + ' logo'} className="m-testimonial-logo glow-inner" />
                ) : (
                  <div className="m-testimonial-fallback glow-inner" title={t.school}>
                    {t.school.split(/\s+/).map(p=>p[0]).slice(0,2).join('').toUpperCase()}
                  </div>
                )}
              </div>
              <blockquote className="m-quote refined-quote"><span className="m-quote-mark" aria-hidden>“</span>{t.quote}</blockquote>
              <figcaption className="visually-hidden">{t.name}, {t.school}</figcaption>
            </div>
          </figure>
        ))}
        </div>
      </div>
    </section>
  );
}

export default function TestimonialsSection(){
  return <TestimonialsCarousel />;
}
